import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import MobileContext from 'context/MobileContext';
import PickHistoryDate from './Header';
import styles from './styles.module.css';
import { download } from 'assets/icons';
import { CircularProgress } from '@mui/material';
import Table from './Table';

const CheckHistoryNew = ({ checkInProps }) => {
  const {
    visits,
    loadHistory,
    checkHistory,
    amount,
    idCA,
    resetHistory,
    loadHistoryPDF,
    isRequestingPDF,
    isRequesting,
  } = checkInProps;
  const isMobile = useContext(MobileContext);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const limit = 15;
  const [used, setUsed] = useState(limit);

  useEffect(() => {
    if (used > amount && typeof amount === 'number') {
      setUsed(amount);
    }
    // eslint-disable-next-line
  }, [amount, checkHistory]);

const data = checkHistory
  ? checkHistory
      .sort((a, b) => Date.parse(a.time) - Date.parse(b.time))
      .map(({ time, club }) => {
        const dateTime = new Date(time);

        const month = (dateTime.getMonth() + 1).toString().padStart(2, '0');
        const day = dateTime
          .getDate()
          .toString()
          .padStart(2, '0');
        const year = dateTime
          .getFullYear()
          .toString()
          .slice(-2);
        const formattedDate = `${month}-${day}-${year}`;

        const hours = dateTime.getHours();
        const minutes = dateTime.getMinutes();
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
        const formattedTime = `${formattedHours}:${minutes
          .toString()
          .padStart(2, '0')} ${ampm}`;

        return {
          date: formattedDate,
          time: formattedTime,
          location: club.name,
        };
      })
  : [];


  const formatDate = date => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${month}-${day}-${year}`;
    return formattedDate;
  };

  const handleDownloadPdf = () => {
    const start = formatDate(startDate);
    const end = formatDate(endDate);
    let data = {
      pdfEnd: end,
      pdfStart: start,
      idCA: idCA,
    };
    loadHistoryPDF(data);
  };

  return (
    <div className={styles.containerMain}>
      <>
        <PickHistoryDate
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          checkHistory={checkHistory}
          visits={visits}
          resetHistory={resetHistory}
          loadHistory={loadHistory}
          limit={!isMobile ? limit : 10000}
          idCA={idCA}
          loadHistoryPDF={loadHistoryPDF}
          setUsed={setUsed}
        />
        <div className={styles.child}>
          {isRequesting ? (
            <CircularProgress size={60} style={{ color: '#FE5000' }} />
          ) : checkHistory.length > 0 ? (
            <>
              <Table data={data} />
              <div className={styles.btnContainer}>
                <div
                  className={`${styles.buttonHistory} ${
                    checkHistory?.length === 0 ? styles.disable : ''
                  }`}
                  onClick={() => {
                    if (checkHistory?.length !== 0) {
                      handleDownloadPdf();
                    }
                  }}
                >
                  {isRequestingPDF ? (
                    <CircularProgress
                      size={20}
                      style={{ color: 'white', marginRight: '20px' }}
                    />
                  ) : (
                    <img src={download} className={styles.iconDownload} alt="" />
                  )}
                  Download PDF
                </div>
              </div>
            </>
          ) : (
            <div className={styles.notFoundText}>History not found.</div>
          )}
        </div>
      </>
    </div>
  );
};
CheckHistoryNew.propTypes = {
  loadHistory: PropTypes.func.isRequired,
  loadHistoryPDF: PropTypes.func.isRequired,
  resetHistory: PropTypes.func.isRequired,
  checkHistory: PropTypes.array.isRequired,
  idCA: PropTypes.string.isRequired,
  isRequestingPDF: PropTypes.bool.isRequired,
  isRequesting: PropTypes.bool.isRequired,
  visits: PropTypes.object.isRequired,
  amount: PropTypes.number,
};
CheckHistoryNew.defaultProps = {
  amount: null,
};
export default CheckHistoryNew;
